import { render, staticRenderFns } from "./uploadOnePic.vue?vue&type=template&id=53913100&scoped=true"
import script from "./uploadOnePic.vue?vue&type=script&lang=js"
export * from "./uploadOnePic.vue?vue&type=script&lang=js"
import style0 from "./uploadOnePic.vue?vue&type=style&index=0&id=53913100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53913100",
  null
  
)

export default component.exports